import {createStyles, makeStyles} from '@material-ui/core';
import {PRIMARY_RED, VZ_LIGHT_GREY} from '../../../const/colors';

const useStyles = makeStyles(() =>
    createStyles({
        container: {
            paddingTop: 16,
        },
        button: {
            borderRadius: '0 3px 3px 0',
            height: 56,
            border: 'none',
            width: 56
        },
        icon: {
            color: PRIMARY_RED,
        },
        adornment: {
            marginRight: '-14px',
        },
    }),
);

export default useStyles;
